module.exports = __webpack_public_path__ + "img/f4.212d5b13.png";